import React from 'react';
import './Styles.css';
import { Link, useNavigate } from 'react-router-dom';
import NavBtns from './NavBtns';
import Footer from './Footer';
import { paragraphs } from './Paragraphs';

// Use relative paths to import images
import img1 from '../assets/1.png';
import img2 from '../assets/2.png';
import img3 from '../assets/3.png';
import img4 from '../assets/4.png';

const section1 = [
  {
    backgroundColor: 'white',
    color: 'black',
    heading: 'Easy-to-type and effective typing challenges',
    text: 'Know your typing speed and perfect your typing with unlimited Free practice sessions.',
    img: img1,
  },
  {
    backgroundColor: 'white',
    color: '#000328',
    heading: ' Take a Test and Discover Surprising Results Instantly!',
    text: 'Explore Easy, Medium, Hard, and other thrilling modes to push your limits and uncover your true typing prowess.',
    img: img2,
  },
];

const section2 = [
  {
    backgroundColor: 'white',
    color: 'black',
    heading: "Master Your Keyboard with Fun Typing Challenges & Customizable Tests",
    text: 'Explore Easy, Medium, Hard, & other Customizeable thrilling modes to push your limits and uncover your true typing prowess.',
    img: img4,
  },
  {
    backgroundColor: 'white',
    color: '#000328',
    heading: 'Visualize Your Typing Progress',
    text: 'View your results in a clear table format and analyze your performance easily.',
    img: img3,
  },
];

const ScoreMap = () => {
  const navigate = useNavigate();

  const handlePlayNow = (selectedParagraphs) => {
    navigate('/playNow', { state: { paragraphs: selectedParagraphs } });
  };

  return (
    <>
      <NavBtns />
      <div className="position-relative overflow-hidden p-3 p-md-4 text-center bg-ctr">
        <div className="col-md-9 p-lg-5 mx-auto my-4">
          <div className="display-3 fw-bold herotxt">
            <h1>Typeathon</h1>
            <p>Discover the Typist in You. Boost Your Typing Speed in Just Minutes Daily</p>
          </div>
          <div className="d-flex gap-3 justify-content-center lead fw-normal">
            <button className='button' onClick={() => handlePlayNow(paragraphs)}>Play Now</button>
            <Link to="/practiceboard" className='button'>Practice Board</Link>
          </div>
        </div>
      </div>
      <div className="2imgsection">
        <div>
          {section1.map((section, index) => (
            <div
              key={index}
              style={{ backgroundColor: section.backgroundColor, color: section.color }}
              className="me-md-2 pt-2 px-2 pt-md-1 px-md-5 text-center overflow-hidden"
            >
              <div style={{ marginTop: '20px' }} className='Tboxescss'>
                <h2 className="display-5">{section.heading}</h2>
                <p className="lead">{section.text}</p>
              </div>
              <img
                src={section.img}
                alt={section.heading}
                style={{ width: '95%', borderRadius: '17px 17px 0px 0px' }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="2imgsection">
        <div>
          {section2.map((section, index) => (
            <div
              key={index}
              style={{ backgroundColor: section.backgroundColor, color: section.color }}
              className="me-md-2 pt-2 px-2 pt-md-1 px-md-5 text-center overflow-hidden"
            >
              <div style={{ marginTop: '20px' }} className='Tboxescss'>
                <h2 className="display-5">{section.heading}</h2>
                <p className="lead">{section.text}</p>
              </div>
              <img
                src={section.img}
                alt={section.heading}
                style={{ width: '95%', borderRadius: '17px 17px 0px 0px' }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="d-flex gap-5 justify-content-center lead fw-normal">
        <button className='button' onClick={() => handlePlayNow(paragraphs)}>Start Playing</button>
        <Link to="/practiceboard" className='button'>Go to Practice Board</Link>
      </div>
      <Footer />
    </>
  );
};

export default ScoreMap;
